module.exports = {"PoSelected":"po-selected","PoCancelledClosedSelected":"po-cancelled-closed-selected","InvoiceSelected":"invoice-selected","ProgramBudgetSelected":"program-budget-selected"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-rule/option-rules.json
// module id = 1P/l
// module chunks = 12